import React from 'react';
import PropTypes from 'prop-types';
import { iconsByType, laClassBySlug, svgBySlug } from './icons';

const defaultClass = 'las la-question-circle';
const companyTypeIcons = {
  agency: 'la la-user-tie',
  employer: 'la la-building',
};

const Icon = ({ type, className, slug }) => {
  if (type !== 'skill') {
    return (<i className={className || iconsByType[type] || companyTypeIcons[slug] || defaultClass} />);
  }

  switch (true) {
    case className:
      return (<i className={className} />);
    case (slug && slug in laClassBySlug):
      return (<i className={laClassBySlug[slug]} />);
    case (slug && slug in svgBySlug): {
      return (
        <i className="svg-icon">
          {svgBySlug[slug]}
        </i>
      );
    }
    case (type && type in iconsByType):
      return (<i className={iconsByType[type]} />);
    default:
      return <i className={defaultClass} />;
  }
};

Icon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf([
    'field', 'role', 'skill', 'soft-skill', 'company', 'country', 'city', 'employment', 'money',
    'benefit', 'rate', 'text', 'language', 'companySize', 'companyType', 'homeoffice',
    'remoteWork', 'suitableFor', 'default']),
  slug: PropTypes.string,
};

Icon.defaultProps = {
  className: null,
  type: 'skill',
  slug: null,
};

export default Icon;
